<script lang="ts" module>
  import { onDestroy } from 'svelte';

  import { type AnalysisResult } from '@/teoCore/text/AnalysisResult';
  import { type TeoText } from '@/teoCore/text/TeoText';
  import TpiDrawer, { type PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';
  import { useTeoTextUiStateObserver } from '@/utils/use-teo-event-observer.svelte';

  import { createPillGroupsFromIndices } from './PerformanceComponent';

  export interface PerformanceComponentProps {
    teoText: TeoText;
  }
</script>

<script lang="ts">
  let { teoText }: PerformanceComponentProps = $props();
  let todoIndicator: string | undefined = $state(undefined);
  const dimensionDrawerOpen = useTeoTextUiStateObserver(teoText.ui, 'dimensionDrawerOpen');
  const dimension = useTeoTextUiStateObserver(teoText.ui, 'dimension');
  const textProperty = useTeoTextUiStateObserver(teoText.ui, 'textProperty');

  let pillgroups: PillGroup[] = $state([]);

  let unsubscribeGotAnalysis = teoText.events.addEventListener('gotAnalysis', onAnalysis);

  onDestroy(unsubscribeGotAnalysis);

  // Correct way to load data if analysis already exists?
  if (teoText.analysis !== null) {
    onAnalysis(teoText.analysis);
  }

  function onAnalysis(result: AnalysisResult) {
    todoIndicator = result.getTodoIndexName();
    pillgroups = createPillGroupsFromIndices(result.getIndices());
  }

  function onDimensionChange(dm: string | undefined) {
    teoText.ui.update('dimension', dm);
  }

  function onTextPropertyChange(tp: string | undefined) {
    teoText.ui.update('textProperty', tp);
  }
</script>

<TpiDrawer
  open={dimensionDrawerOpen.current}
  pillGroups={pillgroups}
  dimension={dimension.current}
  textProperty={textProperty.current}
  {todoIndicator}
  {onDimensionChange}
  {onTextPropertyChange}
  helpTopicName="performance-dimensions"
  useableSubdims={['subdim1', 'subdim2', 'subdim3']}
></TpiDrawer>
